<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <!--  <div class="d-flex flex-column">
                    <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                        <b-col lg="3">
                            <p>Records Totali: {{ rows }}</p>
                        </b-col>

                        <b-col lg="9">
                            <b-pagination :total-rows="rows" v-model="currentPage" :per-page="perPage" align="right" size="sm"> </b-pagination>
                        </b-col>
                    </b-row>
                </div> -->
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>
                        <template #cell(nomePiano)="item">
                            <span>{{ item.item.nomePiano }}</span>
                        </template>
                        <template #cell(nome)="item">
                            <span>{{ item.item.nome || item.item.nomeLetto }}</span>
                        </template>
                        <template #cell(actions)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-secondary" @click="onClickVisualizzaLetto(item)">
                                    <i class="bi bi-eye"></i>
                                </b-button>
                            </b-container>
                        </template>
                        <template #cell(statoAttuale)="row">
                            <!-- <b-badge pill :variant="getStatusVariant(item.item.statoAttuale)">
                                {{ item.item.statoAttuale }}
                            </b-badge> -->
                            <stati-colors-gestione-camere :statoLabel="row.item.statoAttuale || row.item.stato"> </stati-colors-gestione-camere>
                        </template>
                        <template #cell(descrizioneSesso)="item">
                            <span>{{ item.item.descrizioneSesso }}</span>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="d-flex flex-column">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Records Totali: {{ rows }}</p>
                    </b-col>

                    <b-col lg="9">
                        <b-pagination :total-rows="rows" v-model="currentPage" :per-page="perPage" align="right" size="sm"> </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import statiColorsGestioneCamere from "../../utility/statiColorsGestioneCamere.vue";

export default {
    mixins: { UtilityMixin },
    components: { statiColorsGestioneCamere },
    data() {
        return {
            items: [],
            rows: 0,
            storicoMode: false,
            perPage: 50,
            idLetto: null,
            currentPage: 1,
            pathResourceLettoStorico: "/rsapostilettolettostatistorico",
            filtroGestioneCamere: {},
            filtroGestioneCamereStorico: {},
            endpoint: null,
            listKey: 0,
            fields: [
                {
                    label: "*",
                    key: "index",
                    thStyle: "width: 3rem",
                },
                {
                    label: "Piano",
                    key: "nomePiano",
                    sortable: true,
                },
                {
                    label: "Stanza",
                    key: "nomeStanza",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Letto",
                    key: "nome",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Stato",
                    key: "statoAttuale",
                    sortable: true,
                    thStyle: "width: 16rem",
                },
                {
                    label: "Tipologia",
                    key: "descrizioneSesso",
                    sortable: true,
                    thStyle: "width: 8rem",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadDataLetti();
            // console.log("----");
        },
    },
    methods: {
        setParametri(path) {
            let me = this;

            if (path) {
                me.pathResource = path;
            } else {
                me.pathResource = "/rsapostilettoletti";
            }
            // console.log("PATH USATO", me.pathResource);
            me.loadDataLetti();
        },
        loadDataLetti() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroGestioneCamere"]) {
                me.filtroGestioneCamere = JSON.parse(sessionStorage["filtroGestioneCamere"]);
            }
            me.filtroGestioneCamere = { ...me.filtroGestioneCamere, page: me.currentPage, forPage: me.perPage };
            // console.log("filtro in loadData", me.filtroGestioneCamere);
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroGestioneCamere, me.loadDataLettiSuccess, me.loadDataLettiError);
            // console.log("filtro listcmp: ", me.filtroGestioneCamere);
            if (me.pathResource === "/rsapostilettoletti") {
                me.storicoMode = false;
            } else {
                me.storicoMode = true;
            }
            // console.log("STORICO O NO? ", me.storicoMode);
        },
        loadDataLettiStorico(idLetto) {
            let me = this;
            me.idLetto = idLetto;
            let filtroStorico = { idLetto: me.idLetto };
            UtilityMixin.methods.loadDataResources(me.pathResourceLettoStorico, filtroStorico, me.loadDataLettiStoricoSuccess, me.loadDataLettiStoricoError);
            me.$emit("beforeLoadData");
            // console.log("IDLETTO: ", idLetto);
        },
        loadDataLettiStoricoSuccess(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.items = [];
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.listKey++;
        },
        loadDataLettiStoricoError(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            me.$bvToast.toast("Errore durante il caricamento dei letti", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        loadDataLettiSuccess(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.items = [];
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.listKey++;
            // console.log("SUCCESS LETTI", me.items);
        },
        loadDataLettiError(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            me.$bvToast.toast("Errore durante il caricamento dei letti", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onClickVisualizzaLetto(item) {
            let me = this;
            // console.log("CLICK", me.storicoMode);

            if (!me.storicoMode) {
                me.$router.push("/rsagestionecamere/view/" + item.id);
                // console.log("ENTRO PRIMO IF");
            } else {
                me.$router.push("/rsagestionecamerestorico/view/" + item.idLetto);
                // console.log("ENTRO SECONDO IF");
            }

            // console.log("Visualizza item: ", item);
        },
    },
};
</script>

<style></style>
